<template>
  <IconLucideEye />
</template>
